import { render } from "./DadosWidget.vue?vue&type=template&id=ee5e3592"
import script from "./DadosWidget.vue?vue&type=script&lang=js"
export * from "./DadosWidget.vue?vue&type=script&lang=js"

import "./DadosWidget.vue?vue&type=style&index=0&id=ee5e3592&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__